export const routes = [
  // {
  //   name: 'TaskList',
  //   path: '',
  //   component: () => import('./pages/TaskList/index.vue'),
  //   meta: {
  //     title: 'Мои задания',
  //     authorize: [],
  //     searchFilter: 'clones',
  //   },
  // },
  {
    name: 'TaskEdit',
    path: '/edit/:id',
    component: () => import('./pages/TaskCreate.vue'),
    meta: {
      title: 'Редактировать задание',
      authorize: [],
      update: true,
    },
  },
  {
    name: 'TaskGptSettings',
    path: '/gptSettings/:id',
    component: () => import('./pages/TaskGptSettings.vue'),
    meta: {
      title: 'Настройки нейросети',
    },
  },
  {
    name: 'TaskTemplateList',
    path: '/templates',
    component: () => import('./pages/TaskList/index.vue'),
    meta: {
      title: 'Шаблоны заданий',
      authorize: [],
      searchFilter: 'template',
    },
  },
  {
    name: 'TaskCreate',
    path: '/create',
    component: () => import('./pages/TaskCreate.vue'),
    meta: {
      title: 'Добавить задание',
      authorize: [],
      update: false,
      help: 59,
    },
  },
];

export default routes;
